module.exports = __webpack_public_path__ + "static/cover-cf50a104dc290fbb71da7335604e584c.png";